/*
NOTE: this file only temporarily resides in scratch-gui.
Nearly identical code appears in scratch-www, and the two should
eventually be consolidated.
*/

import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import qs from 'query-string';

import MenuBarMenu from './menu-bar-menu.jsx';
import { MenuSection } from '../menu/menu.jsx';
import MenuItemContainer from '../../containers/menu-item.jsx';
import UserAvatar from './user-avatar.jsx';
import dropdownCaret from './dropdown-caret.svg';
import moment from 'moment';

import styles from './account-nav.css';

const AccountNavComponent = ({
    className,
    classroomId,
    isEducator,
    isOpen,
    isRtl,
    isStudent,
    menuBarMenuClassName,
    onClick,
    onClose,
    onLogOut,
    onJoinCourse,
    profileUrl,
    thumbnailUrl,
    username,
    isHome,vip
}) => (
    <React.Fragment>
        <div
            className={classNames(
                styles.userInfo,
                className
            )}
            onMouseUp={onClick}
        >
            {thumbnailUrl ? (
                <UserAvatar
                    className={classNames(
                        styles.avatar,
                        vip ? vip > moment().format("YYYY-MM-DD HH:mm:ss") ? styles.isVip : null :null
                    )}
                    imageUrl={thumbnailUrl}
                />
            ) : null}
            <span className={classNames(
                styles.profileName,
                vip ? vip > moment().format("YYYY-MM-DD HH:mm:ss") ? styles.isVip : null :null
            )}>
                {username}
            </span>
            <div className={styles.dropdownCaretPosition}>
                <img
                    className={styles.dropdownCaretIcon}
                    src={dropdownCaret}
                />
            </div>
        </div>
        <MenuBarMenu
            className={menuBarMenuClassName}
            open={isOpen}
            // note: the Rtl styles are switched here, because this menu is justified
            // opposite all the others
            place={isRtl ? 'right' : 'left'}
            onRequestClose={onClose}
        >
            {
                localStorage.getItem('api-token') && localStorage.getItem('api-token') !== '1703225275PlKsg7j4EJiVHzzwVEKx' &&
                <MenuItemContainer href={profileUrl}>
                    <FormattedMessage
                        defaultMessage="Profile"
                        description="Text to link to my user profile, in the account navigation menu"
                        id="gui.accountMenu.profile"
                    />
                </MenuItemContainer>
            }

            { !isHome ? (
                <React.Fragment>
                    <MenuItemContainer href="/projects/mine">
                        {/* <FormattedMessage
                    defaultMessage="My Stuff"
                    description="Text to link to list of my projects, in the account navigation menu"
                    id="gui.accountMenu.myStuff"
                /> */}
                        {window.L('teach.project.myProjects')}
                    </MenuItemContainer>
                    {/* <MenuItemContainer href="/teacher/classes">
                        {window.L('teach.classes.manage')}
                    </MenuItemContainer> */}
                    {/* <MenuItemContainer onClick={onJoinCourse}>
                        {window.L('teach.course.joinCourse')}
                    </MenuItemContainer> */}
                </React.Fragment>
            ) : null}
            {isStudent ? (
                <MenuItemContainer href={`/classes/${classroomId}/`}>
                    <FormattedMessage
                        defaultMessage="My Class"
                        description="Text to link to my class (if I am a student), in the account navigation menu"
                        id="gui.accountMenu.myClass"
                    />
                </MenuItemContainer>
            ) : null}
            {
                localStorage.getItem('api-token') && localStorage.getItem('api-token') !== '1703225275PlKsg7j4EJiVHzzwVEKx' &&
                <MenuItemContainer href="/settings">
                    <FormattedMessage
                        defaultMessage="Account settings"
                        description="Text to link to my account settings, in the account navigation menu"
                        id="gui.accountMenu.accountSettings"
                    />
                </MenuItemContainer>
            }
            {
                localStorage.getItem('api-token') && localStorage.getItem('api-token') !== '1703225275PlKsg7j4EJiVHzzwVEKx' &&
                <MenuSection>
                    <MenuItemContainer onClick={onLogOut}>
                        <FormattedMessage
                            defaultMessage="Sign out"
                            description="Text to link to sign out, in the account navigation menu"
                            id="gui.accountMenu.signOut"
                        />
                    </MenuItemContainer>
                </MenuSection>
            }
        </MenuBarMenu>
    </React.Fragment>
);

AccountNavComponent.propTypes = {
    className: PropTypes.string,
    classroomId: PropTypes.string,
    isEducator: PropTypes.bool,
    isOpen: PropTypes.bool,
    isRtl: PropTypes.bool,
    isStudent: PropTypes.bool,
    menuBarMenuClassName: PropTypes.string,
    onClick: PropTypes.func,
    onClose: PropTypes.func,
    onLogOut: PropTypes.func,
    onJoinCourse: PropTypes.func,
    profileUrl: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    username: PropTypes.string
};

export default AccountNavComponent;
